import { createPageSegmentLoadMetric } from '@confluence/browser-metrics/entry-points/metricConfigs.ts';
import { WATCH_BUTTON_SEGMENT_KEY } from '@confluence/browser-metrics/entry-points/metric-keys/pageSegmentLoadKey.ts';

export const WATCH_BUTTON_METRIC = createPageSegmentLoadMetric({
	key: WATCH_BUTTON_SEGMENT_KEY,
	ssr: Boolean(window.__SSR_RENDERED__) ? { doneAsFmp: true } : undefined,
});
